/**
 * Converts a given file to a Base64 data URL string
 * @param file The file to convert
 * @return Promise that resolves to the Base64-encoded data URL of the given file
 */
export function convertFileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result as string);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

/**
 * Converts a given url (e.g. Base64) to a File
 * @param url The data to convert
 * @param filename The filename
 * @param mimeType Optional mimetype; defaults to the fetched blob's type, then 'image/png'
 * @return Promise that returns a File based on the given URL
 */
export async function convertUrlToFile(
  url: string,
  filename: string,
  mimeType?: string,
): Promise<File> {
  const blob = await (await fetch(url)).blob();
  return new File([blob], filename, {
    type: mimeType ?? blob.type ?? 'image/png',
  });
}

/**
 * Triggers a browser download for a Blob.
 */
export function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
